<template>
    <div>
        <div class="mt-5 text-center">กำลัง Login Line</div>
    </div>

    <ModalMaster :controller="modalController"></ModalMaster>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import LineFunction from '@/helper/facade/LineFunction.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import CacheHelper from '@/helper/CacheHelper';
import Utility from '@/helper/Utility';

import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
// composable
import useRegisterCardComposable from "@/composables/RegisterCardComposable";

export default {
    name: 'LoginLine',
    mixins: [ModalMixin, LocaleMixin],
    data: function () {
        return {
            liffId: null,
            nonRequiredRegister: ["promotion/hot", "promotion/special4you", "promotion/search", "platinum-service", "faq", "register"],
            apiRegisterCreditCard: null,
        };
    },
    created: function () {

        // clear user
        Account.removeCacheUser()
        this.initLiff();
        // var token = 'eyJraWQiOiI1Y2VlMzdlNjljMzUzNzY2YTNmZTAxZmEwNWJmODIxMjgzNTQxYTg0YTY2OTJjZGVkZGY5NDdkMGMwOTA0MzY3IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2FjY2Vzcy5saW5lLm1lIiwic3ViIjoiVTEyMjI4NmUxYzNhNGQ0MDNjNDE0MGI1NTI5MDE5OWQzIiwiYXVkIjoiMTY1NjYyNTY2NSIsImV4cCI6MTY5MjMyOTk5OCwiaWF0IjoxNjkyMzI2Mzk4LCJhbXIiOlsibGluZXNzbyJdLCJuYW1lIjoidGVzdGVyNSIsInBpY3R1cmUiOiJodHRwczovL3Byb2ZpbGUubGluZS1zY2RuLm5ldC8waDhhWmFHYzVXWjA1bkdIT0pYS2tZR1Z0ZGFTTVFObUVHSDMxOExrWWVNSGNlS2ljY0NTd3VmRVlRUEhsUGYzQWRYMzBzTHhJYU9IdEMifQ.8F2glDcYaYL8WKDAhpvq_XypCRpc2lLuiTi9Y0OqdLjN4MOPUVBDd20NAw_f4NP9z1g_6J25lIEYOaEPId7lKA'
        // this.loginBzbs(token)
        // Load register card composable
        const { apiRegisterCreditCard } = useRegisterCardComposable();
        this.apiRegisterCreditCard = apiRegisterCreditCard;
    },
    methods: {
        onSetupModalCompleted: function () {
            this.initialPdpaModal();
        },
        initLiff: function () {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();
            // this.liffId = "1656407779-DwXBQgj8";
            // this.liffId = "1656625665-PM26ev5B" // local stg
            // console.log(this.liffId)
        
            lineFunction.init(this.liffId).then(() => {
                
                var currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = lineFunction.getIdToken();

                    if (idToken != null) {
                        this.loginBzbs(idToken);
                    } else {
                        // alert('Something error');
                        this.$router.replace('/error');
                    }
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err);
                this.$router.replace('/error');
            });
        },
        loginBzbs: function (idToken) {
            this.apiLoginLine(idToken).then(async(user) => {
                if (user.userLevel <= 0) {

                    this.redirectNotLogin();
                } else {
                    var profile = await this.getProfile();
                    this.checkPdpa(profile);
                    //this.redirectLogin();
                }
            }).catch(() => {
                this.redirectNotLogin()
            });
        },
        apiLoginLine: function (idToken) {
            var cache = new CacheHelper('session')
            cache.setCache('LineIdToken', idToken)

            return new Promise((resolve, reject) => {
                BzbsAuth.apiLoginLine(idToken).subscribe((data) => {
                    // Account.setLogin(data);
                    data.saveCache()
                    resolve(data);
                }, (err) => {
                    reject(err);
                });
            });
        },

        getExtraQueryString: function () {
            let extraQs = JSON.stringify(this.$route.query)
            extraQs = JSON.parse(extraQs)
            // clear target page
            delete extraQs.target_page
            delete extraQs.targetPage

            let qs = "?" + Utility.jsonToQueryString(extraQs)

            if (qs == "?") {
                // don't set query string
                qs = ""
            }

            return qs
        },

        isNonRequiredRegister: function (targetPage) {
            if (!targetPage) {
                return false
            }

            return this.nonRequiredRegister.some(
                (page) => targetPage === page || targetPage.startsWith(page + "/")
            )
        },

        redirectNotLogin: function () {
            var targetPage = this.$route.query.target_page;
            if (!this.isNonRequiredRegister(targetPage)) {
                window.location.replace('/welcome' + this.getExtraQueryString());
            } else {
                window.location.replace("/" + targetPage + this.getExtraQueryString());
                // this.$router.replace("/" + targetPage)
            }

        },

        redirectLogin: function () {
            var targetPage = this.$route.query.target_page; // profile, special4u, promotion/hot
            var source = this.$route.query.source;
            const sessionCache = new CacheHelper("session");
            const cachedTarget = sessionCache.getCache(
                "special4you.redirect.target_page"
            );

            // เช็คกรณี profile และ source=ADA
            if (targetPage === "profile" && source) {
                const cache = new CacheHelper("local");
                cache.setCache("thirdparty.register.source", source);
                sessionCache.removeCache("special4you.redirect.target_page");
                // ไปหน้า profile
                window.location.replace("/profile");
                return;
            }

            // handle case for register
            if (targetPage == "register") {
                targetPage = "profile"; // force to profile because already registered
            } else if (targetPage == "register_creditcard") {
                this.registerCreditCard();
                return;
            } else if (cachedTarget) {
                targetPage = cachedTarget;
            }

            window.location.replace("/" + targetPage + this.getExtraQueryString());
            sessionCache.removeCache("special4you.redirect.target_page");
        },
        //region for register credit card (05/09/2024)
        registerCreditCard: function () {
            const token = Account.getToken();
            const returnUrl = Utility.getWebUrl("webhooks") + "/RegisterdCard?target_page=profile";

            this.apiRegisterCreditCard(token, returnUrl)
                .then((resp) => {
                    if (resp.success) {
                        const cache = new CacheHelper("session");
                        cache.setCache("registerCard.transId", resp.data.tranId);
                        window.location.replace(resp.data.webPaymentUrl);
                    }
                })
                .catch((err) => {
                    this.errorApi(err);
            });
        },
        //end region register credit card
        getProfile: function () {
            return new Promise((resolve) => {
                BzbsProfile.getProfile().subscribe({
                    next: (data) => {

                        resolve(data);
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err, true, {
                            title: this.lbl.default.error,
                        });
                    },
                });
            });
        },
        checkPdpa: async function(user) {
            var currentVersion = await this.getPdpaVersion();
            console.log(user)//isAllowDataPrivacy
            var userTerm = Utility.isNumber(user.profile.isAllowTermAndCondition) ? user.profile.isAllowTermAndCondition : 0;
            var userPrivacy = Utility.isNumber(user.profile.isAllowDataPrivacy) ? user.profile.isAllowDataPrivacy : 0;
            // userTerm = 1;
            // userPrivacy = 0;
            if (userTerm < currentVersion.terms) {
                this.modalController.pdpaModal
                    .clearModal()
                    .setType("terms")
                    .setTitle(this.lbl.register.title.termsAndCond)
                    .setShowCode(false)
                    .changeToConfirmBtn(true)
                    .show();
                 this.modalController.pdpaModal.onClickAccept(async() => {
                    await this.saveConsent("terms", currentVersion.terms);
                    this.modalController.pdpaModal.hide();
                    if (userPrivacy < currentVersion.privacy) {
                        this.modalController.pdpaModal
                            .clearModal()
                            .setType("privacy")
                            .setTitle(this.lbl.register.title.privacy)
                            .setShowCode(false)
                            .changeToConfirmBtn(true)
                            .show();
                        this.modalController.pdpaModal.onClickAccept(async() => {
                            await this.saveConsent("privacy", currentVersion.terms);
                            this.modalController.pdpaModal.hide();
                            this.checkMarketing(currentVersion.marketing);
                        });
                    } else {
                        this.checkMarketing(currentVersion.marketing);
                    }
                });
            } else if (userPrivacy < currentVersion.privacy) {
                this.modalController.pdpaModal
                    .clearModal()
                    .setType("privacy")
                    .setTitle(this.lbl.register.title.privacy)
                    .setShowCode(false)
                    .changeToConfirmBtn(true)
                    .show();
                this.modalController.pdpaModal.onClickAccept(async() => {
                    await this.saveConsent("privacy", currentVersion.terms);
                    this.modalController.pdpaModal.hide();
                    this.checkMarketing(currentVersion.marketing);
                });
            } else {
                this.checkMarketing(currentVersion.marketing);
            }
        },
        checkMarketing: async function (mktCurrentVersion) {
            var data = await this.getConsent();
            if (data.MarketingOption < mktCurrentVersion) {
                this.modalController.marketingModal.show();
                this.modalController.marketingModal.onClickOk(async() => {
                    this.redirectLogin();
                });
            } else {

                this.redirectLogin();
            }
        },
        getPdpaVersion: function() {
            return new Promise((resolve, reject) => {

                BzbsPDPA.apiGetPDPAVersion().subscribe(
                    res => {
                        var terms = res.terms.current_version;
                        var privacy = res.privacy.current_version;
                        var marketing = res.marketing.current_version;
                        resolve({
                            terms: terms,
                            privacy: privacy,
                            marketing: marketing,
                        });
                    },
                    err => {
                        this.errorApi(err);
                        reject();
                    }
                );
            });
        },
        saveConsent: function(type, version) {
            var token = Account.getToken();
            return new Promise((resolve)=>{
                var terms = null;
                var privacy = null;
                if (type == "terms") {
                    terms = version;
                } else {
                    privacy = version;
                }
                BzbsPDPA.apiPostConsent(token, terms, privacy)
                    .subscribe((data) => {
                        console.log(data);
                        // this.redirectLogin();
                        resolve(data);

                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                        // reject(err);
                    });
            });
        },
        getConsent: function() {
            var token = Account.getToken();
            return new Promise((resolve)=>{

                BzbsPDPA.apiGetConsent(token)
                    .subscribe((data) => {
                        console.log(data);
                        // this.redirectLogin();
                        console.log("data", data)
                        resolve(data);

                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                        // reject(err);
                    });
            });
        },
    },
}
</script>
